import get from 'lodash.get';
import status from 'src/js/modules/status';
import statusNames from '../constants/status-names';

const getBillingProfilesStatus = (rootState) =>
  get(status.selectors.getStatus(rootState), statusNames.BILLING_PROFILES);

export default getBillingProfilesStatus;
